import React from "react"
import { graphql } from "gatsby"
import Layout from "./../../layout"
import SEO from "./../../seo"

// s4n
// import "./../assets/sass/pages/_blog.scss"
import { injectIntl } from "gatsby-plugin-intl"
import Tags from "./tags"
import BlogIndexTemplate from "./../templates/blog-index"
import Pagination from './../Pagination'
import kebabCase from "lodash.kebabcase"



const ComponentStateless = (props) => {
  const { intl, propsData } = props;
  const t = intl.formatMessage;

  const { pageContext, aDataCollectionTranslated } = propsData;

  const linkMap = {
    pl: {
      blog: `Blog`,
      news: `Aktualności`,
    },
    en: {
      blog: `Blog`,
      news: `News`,
    },
    de: {
      blog: `Blog`,
      news: `Aktualisierungen`,
    },
    es: {
      blog: `Blog`,
      news: `Actualizaciones`,
    }
  }

  const linkTranslation = kebabCase(linkMap[intl.locale][pageContext.field_type]);

  return (
    <Layout 
      // node={data.node}
    >
        <SEO 
          title={linkMap[intl.locale][pageContext.field_type]} 
          _keywords={``} 
          nodeId={process.env.SOFT4NET_BLOG_PAGE_DRUPAL_ID} 
        />

        <div className="container">
          <h1>{ linkMap[intl.locale][pageContext.field_type] }</h1>
        </div>

        <Tags pageContext={pageContext} linkTranslation={linkTranslation} />

        <BlogIndexTemplate data={propsData} intl={intl} translate={intl.formatMessage} />

        <div className="container">
          <Pagination pageContext={pageContext} linkTranslation={linkTranslation} />
        </div>
    </Layout>
  )
}

export default injectIntl(ComponentStateless)